import React from 'react';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import Categories from '../components/Categories';
import Bestsellers from '../components/Bestsellers';
import ProductSlider from '../components/ProductSlider';
import StatsSection from '../components/StatsSection';
import Testimonials from '../components/Testimonials';
import Footer from '../components/Footer';

export default function Home({
    activeCategory,
    setActiveCategory,
    adminProducts,
    addToCart,
    searchQuery,
    setCurrentPage,
    setIsCartOpen,
    cartCount,
    setSearchQuery,
    onViewDetails,
    pujaProducts,
    herbalProducts,
    jaivikProducts,
    ayurvedicProducts,
    organicProducts
}) {
    return (
        <div className="min-h-screen flex flex-col bg-white">
            {/* Navbar */}
            <Navbar
                cartCount={cartCount}
                setIsCartOpen={setIsCartOpen}
                setActiveCategory={setActiveCategory}
                setCurrentPage={setCurrentPage}
                setSearchQuery={setSearchQuery}
                onViewDetails={onViewDetails}
                adminProducts={adminProducts}
                pujaProducts={pujaProducts}
                herbalProducts={herbalProducts}
                jaivikProducts={jaivikProducts}
                ayurvedicProducts={ayurvedicProducts}
                organicProducts={organicProducts}
            />

            <main className="flex-1 flex flex-col">
                {/* 1. Hero Banner Section */}
                <Hero
                    activeCategory={activeCategory}
                    setActiveCategory={setActiveCategory}
                    setCurrentPage={setCurrentPage}
                />

                {/* 2. Categories Quick Selector Section */}
                <Categories setActiveCategory={setActiveCategory} setCurrentPage={setCurrentPage} />

                {/* 3. Bestsellers Auto-Slider Section */}
                <Bestsellers
                    products={adminProducts}
                    addToCart={addToCart}
                    onViewDetails={onViewDetails}
                    searchQuery={searchQuery}
                />

                {/* 9. Statistics / Info Section */}
                <StatsSection />

                {/* 4. Puja Samagri Auto-Slider */}
                <ProductSlider
                    title="Puja Samagri Collection"
                    subtitle="Pure and traditional items for your daily rituals and auspicious occasions."
                    badge="Divine Essentials"
                    products={pujaProducts}
                    addToCart={addToCart}
                    onViewDetails={onViewDetails}
                />

                {/* 5. Herbal Products Auto-Slider */}
                <ProductSlider
                    title="Herbal Products Range"
                    subtitle="Nourish your skin and hair naturally with authentic herbal extracts."
                    badge="Natural Care"
                    products={herbalProducts}
                    addToCart={addToCart}
                    onViewDetails={onViewDetails}
                />

                {/* 6. Jaivik Products Auto-Slider */}
                <ProductSlider
                    title="Jaivik Products (Chemical-Free)"
                    subtitle="Directly harvested pure Jaivik food items and grains for healthy living."
                    badge="Organic Harvest"
                    products={jaivikProducts}
                    addToCart={addToCart}
                    onViewDetails={onViewDetails}
                />

                {/* 7. Ayurvedic Products Auto-Slider */}
                <ProductSlider
                    title="Ayurvedic Products Formulations"
                    subtitle="Classical immunity boosters and traditional wellness formulations."
                    badge="Ancient Healing"
                    products={ayurvedicProducts}
                    addToCart={addToCart}
                    onViewDetails={onViewDetails}
                />

                {/* 8. Organic Products Auto-Slider */}
                <ProductSlider
                    title="100% Organic Lifestyle Products"
                    subtitle="Wholesome daily essentials crafted for active and healthy living."
                    badge="Wholesome Living"
                    products={organicProducts}
                    addToCart={addToCart}
                    onViewDetails={onViewDetails}
                />



                {/* 10. Customer Testimonials Section */}
                <Testimonials />
            </main>

            {/* 11. Footer Section */}
            <Footer
                setActiveCategory={setActiveCategory}
                setCurrentPage={setCurrentPage}
                adminProducts={adminProducts}
                pujaProducts={pujaProducts}
                herbalProducts={herbalProducts}
                jaivikProducts={jaivikProducts}
                ayurvedicProducts={ayurvedicProducts}
                organicProducts={organicProducts}
                onViewDetails={onViewDetails}
            />
        </div>
    );
}